import { GlobalState } from '../../actions';

export const actionLogSelector = (state: GlobalState) => state.actionLog;

export const actionLogEntitySelector = (state: GlobalState) => actionLogSelector(state).actionCount;